/*
 * View for the search pane of the Topics Area
 */

define([
  "marionette",
  "jquery",
  "messaging/messenger",
  "modules/topicsSplit/topics/topicSearch/template/topicSearchTemplate.html",
  "modules/topicsSplit/topics/topicSearch/template/categorySearchHeaderTemplate.html",
  "modules/topicsSplit/topics/topicSearch/template/categorySearchItemTemplate.html",
  "modules/topicsSplit/topics/topicSearch/template/categorySearchFooterTemplate.html",
  "modules/topicsSplit/topics/topicSearch/template/responseSearchTemplate.html",
  "modules/topicsSplit/topics/topicSearch/template/standardSearchTemplate.html",
  "modules/topicsSplit/topics/topicSearch/template/statusSearchTemplate.html",
  "modules/topicsSplit/topics/topicSearch/template/topicReviewSearchTemplate.html",
  "modules/topicsSplit/topics/topicSearch/template/contextSearchTemplate.html",
  "modules/topicsSplit/topics/topicSearch/template/exampleSearchTemplate.html",
  "modules/topicsSplit/topics/topicSearch/template/labelSearchTemplate.html",
  "modules/typeahead/typeaheadModel",
], function (
  Marionette,
  $,
  Messenger,
  TopicSearchTemplate,
  CategorySearchHeaderTemplate,
  CategorySearchItemTemplate,
  CategorySearchFooterTemplate,
  ResponseSearchTemplate,
  StandardSearchTemplate,
  StatusSearchTemplate,
  TopicReviewSearchTemplate,
  ContextSearchTemplate,
  ExampleSearchTemplate,
  LabelSearchTemplate,
) {
  "use strict";

  const TopicSearchView = {};

  // noinspection JSUnusedGlobalSymbols
  TopicSearchView.topicSearchView = Marionette.ItemView.extend({
    SEARCH_BY_NAME: 1,
    SEARCH_BY_EXAMPLE: 2,
    SEARCH_BY_LABEL: 3,
    SEARCH_BY_RESPONSE: 4,
    SEARCH_BY_STATUS: 5,
    SEARCH_BY_CONTENT: 6,
    SEARCH_BY_DECISION: 7,
    SEARCH_BY_CATEGORY: 8,
    SEARCH_BY_SUB_GROUP: 9,
    SEARCH_BY_TOPIC_REVIEW: 10,
    SEARCH_BY_CONTEXT: 11,
    SEARCH_BY_ATTRIBUTE: 12,
    MAX_CATEGORY_CODES: 5, //no more than 5 sets of category names/values can be used for searching
    template: TopicSearchTemplate,
    initialize: function () {
      this.categoryCount = 0;
      this.trigger("set:topicType", this.model.get("topicTypes").NON_ARCHIVED);
      this.setTemplate();
    },
    events: {
      "change #searchModes": function () {
        const optionSelected = +this.$el.find("#searchModes option:selected").val();
        this.model.set("mode", optionSelected);
        if (optionSelected === this.SEARCH_BY_TOPIC_REVIEW) {
          this.trigger("set:isArchivedAllowed", false);
        } else {
          const showArchivedTopics = Messenger.reqres.request("default:showArchivedTopics");
          this.trigger("set:isArchivedAllowed", showArchivedTopics);
        }
        this.setTemplate();
        this.render();
      },
      "change .categoryCodes": function (event) {
        //get the ID of the selected category code to use for updating the array of category IDs
        const currentTarget = $(event.currentTarget);
        const selectedCategoryIndex = +currentTarget.data("category-index");
        const optionSelected = +currentTarget.val();
        //fetch the array of IDs from the model and update the index that matches the one selected
        const categoryIds = this.model.get("categoryIdArray");
        categoryIds[selectedCategoryIndex] = optionSelected;
        this.model.set("categoryIdArray", categoryIds);
        //also update the array of values to the first item selected
        const categories = this.model.get("categories");
        const category = categories.findWhere({ categoryId: optionSelected });
        const values = category.getValues();
        const categoryValues = this.model.get("categoryValueArray");
        //it's possible that the category code doesn't have any values for it
        //if this is the case, set the default category value to 0
        if (values.length > 0) {
          categoryValues[selectedCategoryIndex] = values.models[0].get("categoryValueId");
        } else {
          categoryValues[selectedCategoryIndex] = 0;
        }

        this.model.set("categoryValueArray", categoryValues);

        this.render();
      },
      "change .categoryCodeValues": function (event) {
        //this works similarly to the change event above
        //get the ID of the selected category value to use for updating the array of category values
        const currentTarget = $(event.currentTarget);
        const selectedCategoryIndex = +currentTarget.data("category-index");
        const optionSelected = +currentTarget.val();
        //fetch the array of category values from the model and update the index that matches the one selected
        const categoryValues = this.model.get("categoryValueArray");
        categoryValues[selectedCategoryIndex] = optionSelected;
        this.model.set("categoryValueArray", categoryValues);
        this.render();
      },
      "click #findTab": function () {
        this.$el.find("#replaceArea").hide();
        this.$el.find("#searchHtmlCheckbox").show();
        this.replaceMode = false;
        //change button name to search
        this.$el.find("button#search").html($.t("topics.search.searchButton"));
      },
      "click #findAndReplaceTab": function () {
        this.$el.find("#replaceArea").fadeIn();
        this.$el.find("#searchHtmlCheckbox").hide();
        this.replaceMode = true;
        //change button name to replace
        this.$el.find("button#search").html($.t("topics.search.replaceButton"));
      },
      "click #addAnother": function (event) {
        event.preventDefault();
        this.addCategorySearchFields();
      },
      "click .removeCategory": function (event) {
        //the div that wraps the remove button is what triggers this event, so we need to get the ID of its child
        const elementToRemove = $(event.currentTarget.children[0]);
        const selectedCategoryIndex = +elementToRemove.data("category-index");
        this.removeCategorySearchFields(selectedCategoryIndex);
      },
      "change input[name='radio']": "onRadioChange",
    },
    onRadioChange: function () {
      const selectedValue = this.$('input[name="radio"]:checked').attr("id");
      this.trigger("set:topicType", selectedValue);
    },
    getAssignee: function () {
      return this.$el.find("#userSearch").val();
    },
    getCreator: function () {
      return this.$el.find("#creatorSearch").val();
    },
    getTime: function () {
      return this.$el.find("#datePicker").datepicker("getDate").getTime();
    },
    getType: function () {
      return this.$el.find("#selType option:selected").val();
    },
    onBeforeRender: function () {
      //if we are searching in cat code mode and a category hasn't been selected, then select the first one from the list
      if (this.model.get("mode") === this.SEARCH_BY_CATEGORY) {
        if (this.model.get("categoryIdArray")[0] === 0 && this.model.get("categories").length > 0) {
          const initCategoryId = this.model.get("categories").at(0).get("categoryId");
          this.model.set("categoryIdArray", [initCategoryId]);
          //also set the initial category value selected to the first one on the list, if any
          const categoryValues = this.model.get("categories").at(0).getValues();
          if (categoryValues.length > 0) {
            const initCategoryValue = categoryValues.at(0).get("categoryValueId");
            this.model.set("categoryValueArray", [initCategoryValue]);
          } else {
            //no category values for this code yet, so we'll set the default to zero
            this.model.set("categoryValueArray", [0]);
          }
        }
      } else {
        //if we are looking in any other mode, reset the categoryId and categoryValue arrays
        this.model.set("categoryIdArray", [0]);
        this.model.set("categoryValueArray", [0]);
      }
    },
    onRender: function () {
      this.$el.i18n();
      //if search by status, set up the datepicker
      if (
        this.model.get("mode") === this.SEARCH_BY_STATUS ||
        this.model.get("mode") === this.SEARCH_BY_TOPIC_REVIEW
      ) {
        const format = Messenger.reqres.request("get:datepicker:date:format");
        const lang = Messenger.reqres.request("get:interface:language");
        this.$el.find("#datePicker").datepicker({
          format: format,
          startDate: "+1d",
          autoclose: true,
          language: lang,
        });
      }
      //set up typeahead when applicable
      if (
        this.model.get("mode") === this.SEARCH_BY_SUB_GROUP ||
        this.model.get("mode") === this.SEARCH_BY_NAME ||
        this.model.get("mode") === this.SEARCH_BY_EXAMPLE ||
        this.model.get("mode") === this.SEARCH_BY_LABEL ||
        this.model.get("mode") === this.SEARCH_BY_DECISION ||
        this.model.get("mode") === this.SEARCH_BY_CONTENT ||
        this.model.get("mode") === this.SEARCH_BY_TOPIC_REVIEW ||
        this.model.get("mode") === this.SEARCH_BY_ATTRIBUTE
      ) {
        //set up the source function to get the typeahead data
        const _this = this;
        const sourceFunction = function (query, process) {
          let localeId = _this.$el.find("#exampleLocale option:selected").val();
          let results;
          const topicType = _this.model.get("topicType");
          switch (_this.model.get("mode")) {
            case _this.SEARCH_BY_SUB_GROUP:
              results = Messenger.reqres.request("substitutions:typeahead", query, topicType);
              break;
            case _this.SEARCH_BY_NAME:
              results = Messenger.reqres.request("topics:typeahead", query, topicType);
              break;
            case _this.SEARCH_BY_EXAMPLE:
              results = Messenger.reqres.request(
                "topic:examples:typeahead",
                query,
                localeId,
                topicType,
              );
              break;
            case _this.SEARCH_BY_LABEL:
              localeId = _this.$el.find("#labelLocale option:selected").val();
              results = Messenger.reqres.request(
                "topic:labels:typeahead",
                query,
                localeId,
                topicType,
              );
              break;
            case _this.SEARCH_BY_DECISION:
              results = Messenger.reqres.request("decisions:typeahead", query, topicType);
              break;
            case _this.SEARCH_BY_CONTENT:
              results = Messenger.reqres.request("contents:typeahead:topicType", query, topicType);
              break;
            case _this.SEARCH_BY_TOPIC_REVIEW:
              results = Messenger.reqres.request("users:typeahead", query);
              break;
            case _this.SEARCH_BY_ATTRIBUTE:
              results = Messenger.reqres.request("attributes:all:typeahead", query);
              break;
            default:
              console.error("Unexpected search mode: " + _this.model.get("mode"));
              results = Messenger.reqres.request("topics:typeahead", query, topicType);
              break;
          }
          results.once(
            "sync",
            function () {
              process(results.getResultsArray());
            },
            this,
          );
        };
        //this handler prevents typeahead from using the "enter" keypress to search by the typeahead suggestion
        this.$el.find("input").on("keyup", function (e) {
          if (e.keyCode === 13) {
            e.stopImmediatePropagation(); //stop typeahead from getting this event
            //now we need to trigger the click:search event, because the propagation was stopped
            _this.trigger("click:search", { view: _this, model: _this.model });
            //and close the typeahead as well
            _this.$el.find(".typeahead").hide();
          }
        });

        //Set up Typeahead.  Tasks are special because they have two typeaheads.
        if (_this.model.get("mode") === _this.SEARCH_BY_TOPIC_REVIEW) {
          this.$el.find("#userSearch").typeahead({
            source: sourceFunction,
            updater: function (item) {
              //set the value of the textbox
              _this.$el.find("#userSearch").val(item);
              return item;
            },
          });

          this.$el.find("#creatorSearch").typeahead({
            source: sourceFunction,
            updater: function (item) {
              //set the value of the textbox
              _this.$el.find("#creatorSearch").val(item);
              return item;
            },
          });
        } else {
          //standard typeahead
          this.$el.find("input").typeahead({
            source: sourceFunction,
            updater: function (item) {
              //set the value of the textbox
              _this.$el.find("input").val(item);
              _this.trigger("click:search", { view: _this, model: _this.model }); //trigger event on view, passing the standard args hash
              return item;
            },
          });
        }
      }
      const el = $("#exampleLocale", this.$el);
      if (el.prop("multiple")) {
        el.select2({
          allowClear: true,
          placeholder: $.t("reports.placeholder.optional.languages"),
        });
      }
    },
    getLanguageChoicesValue: function () {
      return $("#exampleLocale", this.$el).val();
    },
    searchMode: function () {
      return this.model.get("mode");
    },
    setTemplate: function () {
      //default is find-mode, not replace mode
      this.replaceMode = false;
      let template = TopicSearchTemplate;
      //add to this template based on the selected mode
      const mode = this.model.get("mode");
      switch (mode) {
        case this.SEARCH_BY_CATEGORY:
          this.trigger("remove:categories:withEmptyValues");
          this.categoryCount = 1;
          template +=
            CategorySearchHeaderTemplate +
            this.fillInCategorySearchItemIndex(0) +
            CategorySearchFooterTemplate;
          break;
        case this.SEARCH_BY_STATUS:
          template += StatusSearchTemplate;
          break;
        case this.SEARCH_BY_RESPONSE:
          template += ResponseSearchTemplate;
          break;
        case this.SEARCH_BY_TOPIC_REVIEW:
          template += TopicReviewSearchTemplate;
          break;
        case this.SEARCH_BY_CONTEXT:
          template += ContextSearchTemplate;
          break;
        case this.SEARCH_BY_EXAMPLE:
          template += ExampleSearchTemplate;
          break;
        case this.SEARCH_BY_LABEL:
          template += LabelSearchTemplate;
          break;
        default:
          template += StandardSearchTemplate;
      }
      this.template = template;
    },
    removeCategorySearchFields: function (index) {
      //remove the item from the array of category search item templates as well as from the category ID and value arrays
      --this.categoryCount;
      const categoryIds = this.model.get("categoryIdArray");
      categoryIds.splice(index, 1);
      this.model.set("categoryIdArray", categoryIds);
      const categoryValues = this.model.get("categoryValueArray");
      categoryValues.splice(index, 1);
      this.model.set("categoryValueArray", categoryValues);

      //update template to display current number of category name/value pairs
      this.displayCategorySearchFields();
    },
    addCategorySearchFields: function () {
      if (this.categoryCount < this.MAX_CATEGORY_CODES) {
        ++this.categoryCount;
        const categoryIds = this.model.get("categoryIdArray");
        const categoryValues = this.model.get("categoryValueArray");
        if (categoryIds[0] !== 0 && this.model.get("categories").length > 0) {
          //add a new item to the category ID and value arrays and have it set to the first on the list
          categoryIds.push(this.model.get("categories").at(0).get("categoryId"));
          categoryValues.push(
            this.model.get("categories").at(0).getValues().at(0).get("categoryValueId"),
          );
          this.model.set("categoryIdArray", categoryIds);
          this.model.set("categoryValueArray", categoryValues);
        }
        this.displayCategorySearchFields();
      }
    },
    displayCategorySearchFields: function () {
      //start with the search template and the category search header template,
      //then add a category search item template for each set of category name/value used in the search
      //end with adding the footer
      let template = TopicSearchTemplate + CategorySearchHeaderTemplate;
      for (let categoryIndex = 0; categoryIndex < this.categoryCount; ++categoryIndex) {
        template += this.fillInCategorySearchItemIndex(categoryIndex);
      }
      template += CategorySearchFooterTemplate;
      this.template = template;
      this.render();
    },
    fillInCategorySearchItemIndex: function (index) {
      return CategorySearchItemTemplate.replace(/__category_index__/g, index.toString());
    },
    showTopicReview: function () {
      this.$el.find("#topicReviewSearch").removeClass("hidden");
    },
    triggers: {
      "submit form": "click:search",
    },
  });

  return TopicSearchView;
});
